@if (breadcrumbs()) {
  <section>
    <ppg-breadcrumbs [breadcrumbs]="breadcrumbs()!" [rootName]="breadcrumbsHome()" />
  </section>
}

@if (heroBannerContent()) {
  <section class="mt-4">
    <ppg-hero-banner data-test-id="colorFaimilies.heroBanner" [content]="heroBannerContent()!" />
  </section>
}

<section class="section-container" [id]="familySwitcherId">
  <ppg-color-family-switchers-grouped
    [colorFamiliesGroupedByType]="familiesGroupedByType()"
    [selectedColorFamilyWithType]="selectedColorFamily()"
    [customStyle]="familySwitcherStyle()"
    (onGroupedColorFamilySelected)="onColorFamilySelected($event, true)"
    (onDefaultGroupedColorFamilySelected)="onColorFamilySelected($event, false)">
  </ppg-color-family-switchers-grouped>
</section>

@if (familyDescription()?.content?.[0]?.content || familyDescription()?.image?.url) {
  <section class="section-container mt-4" data-test-id="colorFamilies.descriptionSection" [id]="familyDescriptionId">
    <ppg-content-banner
      [content]="familyDescription()!"
      (ctaClicked)="onLaunchColorVisualizerClicked()"></ppg-content-banner>
  </section>
}

<section class="section-container">
  <h2 data-test-id="colorFamilies.sectionHeader">{{ resources.sectionHeader() }}</h2>
  @if (!groupingEnabled && colorsPerFamily()) {
    <ppg-colors-grid
      [colors]="colorsPerFamily()"
      [rows]="paginatorHidden ? colorsPerFamily()?.length! : defaultRowsPerPage"
      (favoriteColorRemoved)="onFavoriteColorRemoved($event)"
      (favoriteColorAdded)="onFavoriteColorAdded($event)"
      (colorDetailsLinkClicked)="onColorDetailsLinkClicked($event)">
    </ppg-colors-grid>
  } @else {
    <ppg-color-family-grouping
      [paginatorHidden]="paginatorHidden"
      [filterOptions]="filterOptions()"
      [colorGroups]="colorFamilyGroups()"
      (favoriteColorRemoved)="onFavoriteColorRemoved($event)"
      (favoriteColorAdded)="onFavoriteColorAdded($event)"
      (colorDetailsLinkClicked)="onColorDetailsLinkClicked($event)"
      (colorInfoGroupChanged)="onColorInfoGroupChanged($event)">
    </ppg-color-family-grouping>
  }
</section>
